// import stores
import mainStore from './stores/mainStore'
import profileStore from './stores/profileStore'
import invitationStore from './stores/invitationStore'
import categoryStore from './stores/categoryStore'
import fieldManagerStore from './components/Pages/FormMaker/FormMakerComponents/formFieldsManager/formFieldManager'
import onboardingStore from './stores/onboardingStore'
import formHeaderStore from './stores/formMakerHeader'
import formGeneralData from './stores/FormGeneralData'

const store = {
  mainStore,
  profileStore,
  invitationStore,
  categoryStore,
  fieldManagerStore,
  onboardingStore,
  formHeaderStore,
  formGeneralData,
}
export default store
